module.exports = __webpack_public_path__ + "img/image5.69ea1930.jpg";